// ==============================找现舱  精品推荐 API==============================
import { jsonPost } from '@/utils/request'

/**
 * @description  现舱列表
 *
 * @export
 * @param {*} params
 */
export function getspacelooklist(params) {
    return jsonPost({
        url: `webspacelook/getspacelooklist`,
        params
    })

}

/**
 * @description  三个列表筛选
 *
 * @export
 * @param {*} params
 */
export function getspacelooklistparams(params) {
    return jsonPost({
        url: `webspacelook/getspacelooklistparams`,
        params
    })

}

/**
 * @description  现舱详情
 *
 * @export
 * @param {*} params
 */
export function getspacelookdetail(params) {
    return jsonPost({
        url: `webspacelook/getspacelookdetail`,
        params
    })

}

/**
 * @description  现舱支付
 *
 * @export
 * @param {*} params
 */
export function weborderpay(params) {
    return jsonPost({
        url: `webspacelook/weborderpay`,
        params
    })

}

/**
 * @description  轮询判断支付
 *
 * @export
 * @param {*} params
 */
export function weborderpaycheck(params) {
    return jsonPost({
        url: `webspacelook/weborderpaycheck`,
        params
    })

}

/**
 * @description  支付失败
 *
 * @export
 * @param {*} params
 */
export function orderpayfail(params) {
    return jsonPost({
        url: `shipspaceorder/orderpayfail`,
        params
    })

}